import VideoPageContainer from "../../components/ExperienceVideos/VideoPageContainer";

export default function AdminVideoPage() {
  return <VideoPageContainer pageTitle="Experience videos" />;
}
